var _rect, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 200,
    viewBox: "0 0 380 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_862_5385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 167,
    width: 296,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 32,
    transform: "translate(0 167)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_862_5385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.172 -54.3276L-32.0516 176.896",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.662 -44.8378L-22.5617 186.386",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.335 -35.1654L-12.8894 196.058",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.007 -25.4931L-3.21703 205.731",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.679 -15.8207L6.45534 215.403",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.169 -6.3309L15.9452 224.893",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.841 3.34146L25.6175 234.565",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.514 13.0138L35.2899 244.238",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.186 22.6862L44.9622 253.91",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.859 32.3585L54.6346 263.582",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.348 41.8484L64.1244 273.072",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.021 51.5207L73.7968 282.745",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.693 61.1931L83.4691 292.417",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.365 70.8654L93.1415 302.089",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.038 80.5378L102.814 311.762",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.528 90.0276L112.304 321.252",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2 99.7L121.976 330.924",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.872 109.372L131.648 340.596",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.545 119.045L141.321 350.269",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.217 128.717L150.993 359.941",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.707 138.207L160.483 369.431",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.379 147.879L170.155 379.103",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.052 157.552L179.828 388.775",
    stroke: "#E5E7EB",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167H380",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296 200L296 2.88611e-06",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296 95L380 95",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296 23L380 23",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnBg2);
export default __webpack_public_path__ + "static/media/learn-bg-2.d0eb90dfcf3f1f53dcfb18e9710008ab.svg";
export { ForwardRef as ReactComponent };